module.exports = __webpack_public_path__ + "img/twitter_example_1.2fc9e393.jpg";